module.exports = __webpack_public_path__ + "static/img/deviceItem_gray.7e7dd7ae.png";